import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { shallowEqual } from 'react-redux';
import { isConfigFlagEnabled } from '../../../config';
import { addTableShakeAnimation } from '../../../redux/actions/animationsActions';
import { selectActionSeatTimeProperties } from '../../../redux/reducers/pokerReducer';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { useReduxStore } from '../../../redux/useReduxStore';
import { maybePlayTimeRunningOutSound } from '../../../utils/soundUtils';
import { isTestEnvironment } from '../../../utils/utils';
import { ActiveTimerBar } from '../pixiComponents/activeTimerBar';
import { InactiveTimerBarContainer } from './inactiveTimerBarContainer';
export const PlayerActionTimerBarContainer = ({ seatIndex, w, h }) => {
    const dispatch = useAppDispatch();
    const { getState } = useReduxStore();
    const actionSeatTimeProperties = useAppSelector((state) => selectActionSeatTimeProperties(state, seatIndex), shallowEqual);
    const isMyTurn = useAppSelector((state) => !!state.poker.myTurnProperties);
    const maybePlaySound = useCallback(() => {
        if (!isMyTurn) {
            return;
        }
        maybePlayTimeRunningOutSound(getState());
    }, [getState, isMyTurn]);
    const quarterRemainingCallback = useCallback(() => {
        if (isConfigFlagEnabled('tableShakeAnimations') &&
            isConfigFlagEnabled('expiringTimeTableShakeAnimation') &&
            !isConfigFlagEnabled('expiringTimePlayerShakeAnimation') &&
            isMyTurn &&
            actionSeatTimeProperties) {
            const remainingMs = actionSeatTimeProperties.startTimestampMs + actionSeatTimeProperties.totalMs - performance.now();
            if (remainingMs > 0) {
                dispatch(addTableShakeAnimation({
                    type: 'vibrate',
                    durationMs: remainingMs,
                    maxVibratePx: 10,
                    isIncreasingStrength: true
                }));
            }
        }
        maybePlaySound();
    }, [maybePlaySound, isMyTurn, dispatch, actionSeatTimeProperties]);
    if (!actionSeatTimeProperties) {
        return _jsx(InactiveTimerBarContainer, { seatIndex: seatIndex, containerW: w });
    }
    const pixiData = isTestEnvironment() ? { type: 'active-timer', seatIndex } : null;
    return (_jsx(ActiveTimerBar, { startTimestampMs: actionSeatTimeProperties.startTimestampMs, totalMs: actionSeatTimeProperties.totalMs, x: -w / 2, y: -h / 2, w: w, h: h, halfRemainingCallback: maybePlaySound, quarterRemainingCallback: quarterRemainingCallback, pixiData: pixiData }));
};
